exports = module.exports = require("../../../../node_modules/.pnpm/css-loader@3.2.0_webpack@4.46.0/node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "html .cog-content pre,:root:root:root:root:root .cog-content pre{white-space:pre-wrap}", ""]);
